import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Roboto, sans-serif", // Roboto fontunu burada ayarlayın
  },
});

export { theme };
